<template>
  <div class="currencies">
    <page-header title="Currencies" icon="dollar-sign">
      <div slot="sub-title">
        Currency management
      </div>
      <div slot="controls">
        <el-button type="primary" icon="el-icon-plus" @click="showDialog = true" plain>Add currency</el-button>
      </div>
    </page-header>

    <el-row :gutter="20" class="body-padding">
      <el-col :span="24">
        <currency-list :currencies="currencies" v-if="loaded" />
      </el-col>
    </el-row>

    <el-dialog :append-to-body="true" append-to-body width="400px" title="Add currency" :visible.sync="showDialog">
      <upsert-form v-if="showDialog" @add="addCurrency" />
    </el-dialog>

  </div>
</template>

<script>
import CurrencyList from './CurrencyList'
import UpsertForm from './UpsertForm'

export default {
  name: 'Currencies',
  components: { CurrencyList, UpsertForm },
  data () {
    return {
      showDialog: false,
      loaded: false,
      currencies: []
    }
  },
  methods: {
    addCurrency (currency) {
      this.currencies.unshift(currency)
      this.showDialog = false
    },
    async getCurrencies () {
      const response = await this.$http.get(this.$api.currencies.index)
      this.currencies = response.data
      this.loaded = true
    }
  },
  created () {
    this.getCurrencies()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/currencies/Currencies.vue